import styled from 'styled-components';

interface ImageWrapperProps {
  $width: string;
  $height: string;
}

export const ImageWrapper = styled.div<ImageWrapperProps>`
  display: flex;
  align-items: center;
  flex-grow: 0 !important;
  height: ${({ $height }) => $height};

  img {
    width: ${({ $width }) => $width};
  }
`;
